export const LOADING_SCREEN_IMAGE = "https://dapulse-res.cloudinary.com/image/upload/v1658398201/monday_platform/signup/loader_transparent_new.gif";
export const LOADING_SCREEN_IMAGE_ALT = "Loading...";
